import type { Track } from "@similarweb/tracking-provider";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export function createLeadsSearchTrackingService(track: Track) {
    return {
        trackInCRMCellClick(type: CrmIntegrationProvider, companyName?: string) {
            track("Table", "click", createTrackingEventName("open CRM link", type, companyName));
        },

        trackLeadPriorityClick(priority: string) {
            track("Table", "click", `Priority/${priority}`);
        },

        trackLinksClick(linkType: string, companyName: string, url: string) {
            const eventName = createTrackingEventName(`open company ${linkType}`, url, companyName);
            track("Table", "click", eventName);
        },
        trackSidebarToggle(isOpen: boolean) {
            track("Table", "click", `sidebar toggle/${isOpen ? "closed" : "open"}`);
        },
        trackCompanyCellClick(companyName: string) {
            track("Table", "click", `open company overview/${companyName}`);
        },
        trackSaveToListHookClick() {
            track("sales intelligence hooks", "click", "Add to list hook");
        },
        trackExportHookClick(variant: "contact" | "upgrade" = "contact") {
            track("sales intelligence hooks", "click", `Export hook/${variant}`);
        },
        trackInCRMHookClick() {
            track("sales intelligence hooks", "click", "In CRM hook");
        },

        trackSaveSearchClicked(activeFiltersTrackingNames: readonly string[], numberOfResults: number) {
            track(
                "lead gen filter actions",
                activeFiltersTrackingNames.toString(),
                createTrackingEventName("save search", activeFiltersTrackingNames.length, numberOfResults),
            );
        },
    };
}
